<div class="course-form">

  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-mail-bulk" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">Submissions</h1>
      <p class="cf-head__sub">{{assessmentName}}</p>
    </div>
    <div class="cf-head__actions">
      <button class="btn m-0" type="button" title="Export" (click)="exportToExcel()"
        [disabled]="!assessmentSubmissionList || assessmentSubmissionList.length === 0">
        <i class="fas fa-file-export" aria-hidden="true"></i> Export
      </button>
    </div>
  </header>

  <section class="cf-card">
    <!-- id kept: TableUtil.exportTableToExcel reads this table out of the rendered page by id. -->
    <div class="cf-table-wrap">
      <table id="submissionlist" class="cf-table">
        <thead>
          <tr>
            <th scope="col" class="cf-table__num">S/No</th>
            <th scope="col">Student</th>
            <th scope="col">Submitted at</th>
            <th scope="col">Total Score</th>
            <th scope="col">Percentage</th>
          </tr>
        </thead>
        <tbody>
          <!-- The row used to carry the routerLink itself, so a submission could only be opened
               with a mouse. The link is now a real anchor on the student's name, which the
               keyboard can reach, and the row still highlights on hover. -->
          <tr *ngFor="let submision of assessmentSubmissionList; let currentIndex = index" class="cf-table__row">
            <td class="cf-table__num">{{currentIndex + 1}}</td>
            <td>
              <a class="text-link font-weight-600" routerLink="/user/scoreassessment"
                [queryParams]="{aid: this.assessmentID, stid : submision.studentid, classid : this.classID, moduleid: this.moduleId, batchid: this.batchID}">
                {{submision.studentname}}
              </a>
            </td>
            <td class="text-muted">{{submision.submitdate}}</td>
            <td>
              <span *ngIf="submision.scored; else notScored">{{submision.score}}/{{submision.totalmarks}}</span>
            </td>
            <td>
              <span *ngIf="submision.scored; else notScoredPct">{{submision.percentagescore}}</span>
            </td>
            <ng-template #notScored><span class="cf-pill">Not marked</span></ng-template>
            <ng-template #notScoredPct><span class="text-muted">—</span></ng-template>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="cf-empty" *ngIf="assessmentSubmissionList && assessmentSubmissionList.length === 0">
      No one has submitted this assessment yet.
    </p>
  </section>
</div>
